<template>
  <b-card :title="$t('content')">
    <ul>
      <div v-if="isUserAdmin" >
        <li>
          <b-link to="/reports/reports">{{ $t('reports')}}</b-link>
        </li>
        <li>
          <b-link to="/reports/bokbasenOrders">{{ $t('bokbasenOrders') }}</b-link><br>
        </li>
        <li>
          <b-link to="/reports/biblio">{{ $t('biblio') }}</b-link>
        </li>
        <li>
          <b-link to="/reports/reconciliation">{{ $t('reconciliation') }}</b-link>
        </li>
        <li>
          <b-link to="/reports/scheduledjobs">{{ $t('scheduledJobs') }}</b-link>
        </li>
        <li>
          <b-link to="/reports/email">{{ $t('email') }}</b-link>
        </li>
      </div>
    </ul>
  </b-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { isAdmin } from '@/services/PermissionService';
  export default {
    name: 'LinksPanel',
    data () {
      return {
        userRoles: []
      }
    },
    computed: {
      ...mapGetters('oidcStore', ['oidcUser']),
      isUserAdmin () {
        return isAdmin(this.oidcUser?.username);
      }
    },
    mounted () {
      this.userRoles = this.oidcUser?.roles || []
    }
  }
</script>
